import { useTranslation } from 'react-i18next';

import {
  FormatCurrencyForDisplay,
  SkeletonLoader,
} from '@unified-checkout/design-system';
import { EMPTY_VALUE } from '@app/dashboard/constants/shared';
import { useLangStore } from '@app/dashboard/store/lang';

import type { ITransferSUmmaryProps } from '@app/dashboard/types/innerLayout/balance_and_transfers/single-transfer/summary';

import { formatAmountWithCurrency } from '../../../../utils';
import TransferSummary from '../../../../components/TransferSummary';
import TransferBadge from '../../../../components/TransferBadge';

import styles from './summary.module.scss';

const Summary = ({
  isLoading,
  transferSummary,
  header,
  expectedArrival,
  transactionCount = 0,
}: ITransferSUmmaryProps) => {
  const { t } = useTranslation();
  const { lang } = useLangStore();

  const formattedAmount = header?.amount
    ? formatAmountWithCurrency({
        amount: header?.amount,
        currency: header?.currency,
        lang,
      })
    : EMPTY_VALUE;

  return (
    <div className={styles['transfer-summary']}>
      {isLoading ? (
        <SkeletonLoader type="bordered_box" width="100%" height="15.875rem" />
      ) : (
        <div className={styles['transfer-summary__bank-details']}>
          {header && <TransferBadge header={header} />}
          <p className={styles['transfer-summary__bank-details__note']}>
            {t('innerLayout.balanceTransfers.singleTransfer.bank.note')}
          </p>
          <p className={styles['transfer-summary__bank-details__amount']}>
            {FormatCurrencyForDisplay(formattedAmount)}
          </p>
          <p className={styles['transfer-summary__bank-details__destination']}>
            {header?.subtitle || EMPTY_VALUE}
          </p>
          <p className={styles['transfer-summary__bank-details__bank']}>
            {transferSummary?.bank || ''}
          </p>
        </div>
      )}
      <TransferSummary
        isLoading={isLoading}
        transferSummary={transferSummary}
        expectedArrival={expectedArrival}
        status={header?.status.key}
        transactionCount={transactionCount}
      />
    </div>
  );
};

export default Summary;
